export default function Marquee({ items, className = "", speed = "slow" }) {
  const anim = speed === "fast" ? "animate-marquee" : "animate-marquee-slow";
  const seq = [...items, ...items];
  return (
    <div className={`relative overflow-hidden ${className}`} data-testid="marquee">
      <div className={`flex whitespace-nowrap ${anim} w-max`}>
        {seq.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="mx-8">{it}</span>
            <span className="opacity-40">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
